























import store from '@/store';
import LabelInput from '@/views/molecules/LabelInput.vue'
import ActiveButton from '@/views/atoms/ActiveButton.vue'
import RightBox from '@/views/molecules/RightBox.vue'
import ApiClient from '@/common/api'

export default
  name: 'Login'
  components: {
    LabelInput
    RightBox
    ActiveButton
  }

  created: () ->
    store.dispatch('initPostParam')
    api = new ApiClient()
    await api.initToken()
    # store.dispatch('setAdminData', {})

  data: () ->
    error_message: ''

  methods: {
    click: (e) ->
      api = new ApiClient()
      await api.initToken()
      api = new ApiClient()
      data = await api.post('/admin/login/login')
      if data.state == 200
        store.dispatch('setAdminData', data.user_data)
        @$router.push '/admin/top'
        return
      @error_message = data.errors.loginid.error
  }
